import type {Server} from '../../../../types'

import {GridCard} from '../GridCard/GridCard'

import styles from './GridSection.module.css'

type Props = {
  mcps: Server[]
}

export function GridSection(props: Props) {
  const {mcps} = props

  return (
    <section className={styles.grid}>
      {mcps.map(mcp => (
        <GridCard key={mcp.id} mcp={mcp} />
      ))}
    </section>
  )
}

try{ GridSection.displayName ||= 'GridSection' } catch {}